<template>
  <div class="flex h-screen bg-gray-100">
    <sidebar :menu-items="menuItems" />
    <div class="flex-1 flex flex-col overflow-hidden">
      <!-- Top Header -->
      <header>
        <div
          class="mx-auto pt-8 pb-4 px-4 sm:px-6 lg:px-8 flex justify-between items-center"
        >
          <h2 class="text-3xl font-semibold text-gray-800">{{ pageTitle }}</h2>
          <div class="flex items-center">
            <p class="mr-4 text-gray-500">
              {{ getTodayDate() }}
            </p>
            <button class="p-2 rounded-full bg-gray-200 mr-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
                />
              </svg>
            </button>
            <button class="p-2 rounded-full bg-gray-200 mr-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
                />
              </svg>
            </button>
            <div class="avatar placeholder">
              <div class="bg-neutral text-neutral-content w-9 rounded-full">
                <span v-if="authStore.user" class="font-semibold">{{
                  authStore.user.initials
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </header>

      <!-- Main Content -->
      <main class="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100">
        <div class="mx-auto py-6 sm:px-6 lg:px-8">
          <div class="flex-grow">
            <router-view></router-view>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import Sidebar from "@/components/ui/sidebar/SidebarView.vue";
import { useTimeManagement } from "@/composables/time/useTimeManagement";

const route = useRoute();
const authStore = useAuthStore();

const pageTitle = computed(() => {
  // Logic to determine page title based on current route
  return route.meta.title || "Dashboard";
});

const { getTodayDate } = useTimeManagement();

// This should be passed from the parent component or managed by a state management solution
const menuItems = [
  { name: "Pagrindinis", path: "/", icon: "dashboard" },
  { name: "Žemėlapis", path: "/data/view", icon: "map" },
  { name: "Vartotojai", path: "/users", icon: "users" },
  { name: "Dokumentacija", path: "/support/documentation", icon: "help" },
  // { name: "Nustatymai", path: "/settings", icon: "settings" },
];
</script>
